import * as firebase from "firebase";
import { auth } from "firebase";
import { firebaseConfig } from "~/config";

import {
    isSubObject
} from "~/fp";

var config = {
    apiKey: firebaseConfig.API_KEY,
    authDomain: firebaseConfig.AUTH_DOMAIN,
    databaseURL: firebaseConfig.DATABASE_URL,
    storageBucket: firebaseConfig.STORAGE_BUCKET
};


const _fbApp = firebase.initializeApp(config);
const ERROR_NULL_NODE = "Node is null";
const debugSnapShot = (resolve: Function, reject: Function) =>
    (sn: any) => sn.val() === null ? reject(ERROR_NULL_NODE) : resolve(sn.val());

// Facebook login demo
let providerFB = new auth.FacebookAuthProvider();
providerFB.setCustomParameters({
    'display': 'popup'
});

// Google login demo
let providerGG = new auth.GoogleAuthProvider();
providerGG.setCustomParameters({
    'display': 'popup'
});

// utils functions

/**
 * 
 * @param node ref firebase node
 * @param data data to set or update
 */
const setNode = (node: string, data: object) => {
    return new Promise((resolve, reject) => {
        _fbApp.database()
            .ref(node)
            .set(data)
            .then(() => resolve(data))
    })
}




/**
 * 
 * @param node ref firebase node
 */
const getNode = (node: string) => {
    return new Promise((resolve, reject) => {
        _fbApp.database().ref(node).once('value')
            .then(debugSnapShot(resolve, reject))
    })
}

/**
 * 
 * @param node  ref firebase node
 * @param data  new data for ref
 */
const addNewRef = (node: string, data: object) => {
    return new Promise((resolve, reject) => {
        const newRef = _fbApp.database().ref(node).push();
        newRef
            .set({
                id: newRef.key,
                ...data
            })
            .then(() => resolve({ id: newRef.key, ...data }))
    })
}

const addRefIfNotExists = (node: string, child: string, equalTo: string, data: object) => {
    return new Promise((resolve, reject) => {
        getNodeOrderBy(node, child, equalTo)
        .then(reject)
        .catch(er => {
            addNewRef(node, data)
            .then(resolve)
            .catch(reject)
        })
    })
}

/**
 * 
 * @param node 
 * @param child 
 * @param equalValue 
 */
const getNodeOrderBy = (node: string, child: string, equalValue: any) => {
    return new Promise((resolve, reject) => {
        _fbApp.database().ref(node)
        .orderByChild(child).equalTo(equalValue)
        .once("value")
            .then(debugSnapShot(resolve, reject))
    })
}

/**
 * 
 * @param node 
 * @param child 
 * @param equalValue 
 * @param entries 
 */
const getDeepWithOrderBy = (node: string, child: string, equalValue: string, entries: object) => {
    return new Promise((resolve, reject) => {
        getNodeOrderBy(node, child, equalValue)
        .then(data => {
            const tmp = Object.entries(data).find(([key, value]) => isSubObject(value, entries))
            return tmp ? resolve(tmp[1]) : reject(ERROR_NULL_NODE)
        })
        .catch(reject)
    })
}

export default _fbApp;

export {
    providerFB,
    providerGG,
    setNode,
    getNode,
    addNewRef,
    getNodeOrderBy,
    getDeepWithOrderBy,
    addRefIfNotExists
}


// WEBPACK FOOTER //
// ./src/firebase.ts